/**
 * Turns the API's highlight marks into renderable pieces — never HTML.
 * Latin marks are [offset, length] character ranges; Arabic marks are word
 * indexes into the Uthmani text split on whitespace.
 */

/** @returns {{ text: string, marked: boolean }[]} */
export function segmentsFromRanges(text, ranges = []) {
  if (!ranges?.length) return [{ text, marked: false }];

  const sorted = [...ranges].sort((a, b) => a[0] - b[0]);
  const out = [];
  let cursor = 0;

  for (const [offset, length] of sorted) {
    const start = Math.max(offset, cursor);
    const end = offset + length;
    if (end <= cursor) continue;
    if (start > cursor) out.push({ text: text.slice(cursor, start), marked: false });
    out.push({ text: text.slice(start, end), marked: true });
    cursor = end;
  }

  if (cursor < text.length) out.push({ text: text.slice(cursor), marked: false });
  return out;
}

export const arabicWords = (text) => text.trim().split(/\s+/u);

/** A word without its Quranic pause marks — what to look up when it's tapped. */
export const lookupForm = (word) =>
  word.replace(/[ۖ-ۭؐ-ؚ]/gu, '').trim();

const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';
export const toArabicDigits = (n) => String(n).replace(/\d/g, (d) => ARABIC_DIGITS[d]);
